import { useMemo } from "react";
import type { EventContext } from "../engines/event-map-kit.js";
import { readSnapshot } from "../data/snapshot.js";
import { getEventContext } from "../data/shot-pass.js";

// Phase 02-style seam for the EventMapKit's data context (match results, goal
// timelines, the player roster by id). Built once — the snapshot is static. At the
// Part-2 cutover this adapts app-api's /matches + /match-goals + player index into the
// same EventContext shape.
export function useEventContext(): EventContext {
  return useMemo(() => getEventContext(readSnapshot()), []);
}
